import { render } from "./ProdutoRepeticaoAlteracao.vue?vue&type=template&id=f43f2fe4&scoped=true"
import script from "./ProdutoRepeticaoAlteracao.vue?vue&type=script&lang=js"
export * from "./ProdutoRepeticaoAlteracao.vue?vue&type=script&lang=js"

import "./ProdutoRepeticaoAlteracao.vue?vue&type=style&index=0&id=f43f2fe4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43f2fe4"]])

export default __exports__